<template lang="pug">
.athletes
  h3(v-if="title") {{ __(title, 'auto') }}
  .athlete-grid
    .athlete-class(v-for="athlete in athletes")
      .athlete
        DynamicMedia.photo(
          v-if="athlete.img"
          :config="athlete.img"
          contain
        )
        .description
          .name {{athlete.name}}
          .country
            StaticImage.flag-thumb(alt="" :src="`cms/rogue%20challenge/flags/${athlete.flag}.svg`")
            span {{__(athlete.country, 'auto')}}
</template>

<script setup lang="ts">
defineProps({
  title: {
    type     : String,
    required : false,
  },
  athletes: {
    type    : Array,
    default : () => ([]),
  },
})
</script>

<style scoped lang="scss">
.athlete-grid {
  display: grid;
  grid-template-columns: repeat(5, 20%);
  grid-row-gap: $space-m;
  grid-column-gap: $space-m;

  @media (max-width: 1475px) {
    grid-template-columns: repeat(5, 19%);
  }

  @include tablet-and-small-desktop() {
    grid-template-columns: repeat(3, 33%);
  }

  @include mobile() {
    grid-template-columns: repeat(2, 1fr);
  }

   @media (max-width: 420px) {
    grid-template-columns: repeat(1, 100%);
    margin-left: $space-m;

    .athlete-class .athlete .photo{
      max-width: 120px;
      height: 120px;
      margin-right: $size-m;
    }

    .athlete-class .athlete .country .flag-thumb {
      width: 50px;
      height: 32px;
    }
  }

}

.athletes h3 {
  padding-left: $size-s;
  margin-bottom: 4px;
}

.athlete-class {
  .athlete {
    display: flex;

    .name {
      font-weight: bold;
      padding-bottom: $space-xxs;
    }

    .photo {
      max-width: 90px;
      height: 90px;
      margin-right: $space-xs;
    }

    .country {
      display: flex;
      align-items: center;

      .flag-thumb {
        width: 38px;
        height: 24px;
        margin-right: $space-xxs;
        justify-content: center;
      }

      @include mobile() {
        flex-direction: column;
        align-items: flex-start;
        .flag-thumb {
          margin-bottom: $space-xs;
        }
      }
    }

    span {
      font-family: $font-condensed;
    }
  }

}

</style>
